import { Content } from "../../squidex";

export class TemplateModel extends Content {

    constructor(current?: Content) {
        super(current);
    }
}
